"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPage = void 0;
var react_1 = __importDefault(require("react"));
var constellation_1 = require("@zillow/constellation");
var StatsTableHeader = function () {
    return (react_1.default.createElement(constellation_1.Table.Header, { appearance: "dark" },
        react_1.default.createElement(constellation_1.Table.Row, null,
            react_1.default.createElement(constellation_1.Table.HeaderCell, null, "name"),
            react_1.default.createElement(constellation_1.Table.HeaderCell, null, "count"),
            react_1.default.createElement(constellation_1.Table.HeaderCell, null, "external url"))));
};
var StatsTableBody = function (_a) {
    var stats = _a.stats;
    return (react_1.default.createElement(constellation_1.Table.Body, null, stats.map(function (stat) {
        return (react_1.default.createElement(constellation_1.Table.Row, { key: stat.name },
            react_1.default.createElement(constellation_1.Table.HeaderCell, null, stat.name),
            react_1.default.createElement(constellation_1.Table.Cell, null, stat.count),
            react_1.default.createElement(constellation_1.Table.Cell, null, stat.url && react_1.default.createElement(constellation_1.Anchor, { href: stat.url }, "view"))));
    })));
};
var StatsTable = function (_a) {
    var stats = _a.stats, statName = _a.statName;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(constellation_1.Heading, { level: 4 }, statName),
        react_1.default.createElement(constellation_1.Spacer, { marginBottom: "xs" }),
        react_1.default.createElement(constellation_1.Table, { "aria-label": "Medium-sized grid table", size: "md", key: statName },
            react_1.default.createElement(StatsTableHeader, { statName: statName }),
            react_1.default.createElement(StatsTableBody, { stats: stats })),
        react_1.default.createElement(constellation_1.Spacer, { marginBottom: "md" })));
};
var StatsPage = function (props) {
    var statsByName = props.statsByName;
    var statNamesArray = Object.keys(statsByName).sort(function (a, b) {
        if (a < b) {
            return -1;
        }
        else if (a > b) {
            return 1;
        }
        return 0;
    });
    return (react_1.default.createElement(constellation_1.Page, null,
        react_1.default.createElement(constellation_1.PageTitle, { heading: react_1.default.createElement(constellation_1.Heading, { level: 1 }, "Stats Page") }),
        react_1.default.createElement(constellation_1.PageContent, null,
            react_1.default.createElement(constellation_1.UpsellBanner, { actionButton: react_1.default.createElement(constellation_1.TextButton, null, "view documentation"), body: react_1.default.createElement(constellation_1.Text, null, "these stats are recorded via @zg-rentals/particles-js-notify") }),
            react_1.default.createElement(constellation_1.Spacer, { marginY: "md" }),
            statNamesArray.map(function (statName) {
                var statsConfig = statsByName[statName];
                if (statsConfig && statsConfig.stats) {
                    return react_1.default.createElement(StatsTable, { stats: statsConfig.stats, statName: statName });
                }
                return null;
            }))));
};
exports.StatsPage = StatsPage;
StatsPage.displayName = 'StatsPage';
//# sourceMappingURL=StatsPage.js.map